import React from 'react';
import './App.css';
import Page from './page/Page';

function App() {
  return (
    <div className='flex lg:flex-row sm:flex-col justify-between items-center h-screen'>
    <Page />
    </div>
  );
}

export default App;
